import React, { useState } from "react";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../../utils/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Accuracy_Edit_Offcanvas from "../Accuracy_Edit_Offcanvas/Accuracy_Edit_Offcanvas";
import Delete_offcanvas from "../../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../../utils/fixIDS";
import {
  Delete,
  GetAll,
} from "../../../../../../../../features/admin/quality_management/process_requirement/accuracy/Slice";

function Accuracy_table({ accuracydetails, currentPage, setCurrentPage, fetchCustomers }) {
  const accuracies = accuracydetails?.data || [];

  // const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = accuracydetails?.per_page;

  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const dispatch = useDispatch();

  const totalPages = accuracydetails?.total_pages;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      fetchCustomers(currentPage); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(FixIDS.accuracy.Edit);
  const haveDeletePermission = permissions?.includes(FixIDS.accuracy.Delete);

  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th rowSpan="2">Sr. No</th>
                <th rowSpan="2">Date</th>
                <th rowSpan="2">Test Method</th>
                <th rowSpan="2">Sample Id</th>
                <th rowSpan="2">Check By</th>
                <th rowSpan="2">Remark</th>
                <th rowSpan="2">Type Verification Of</th>

                <th colSpan="2">Certified</th>
                <th rowSpan="2">Tested Value</th>
                <th rowSpan="2">Accuracy Acceptance</th>
                <th rowSpan="2">Certified Value (Overall)</th>
                <th rowSpan="2">Action</th>

                {/* <th colSpan="2">certified_value</th> */}
              </tr>
              <tr>
                <th>Parameter</th>
                <th>Value</th>
              </tr>
            </thead>

            <tbody>
              {accuracies.length === 0 && (
                <tr>
                  <td colSpan="10" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}

              {accuracies?.map((accuracy, index) =>
                accuracy.Accuracy_Parameters?.map((param, paramIndex) => (
                  <tr key={`${accuracy.id}-${param.id}`}>
                    {/* Sr No + Type Verification */}
                    {paramIndex === 0 && (
                      <>
                        <td rowSpan={accuracy.Accuracy_Parameters.length}>
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </td>

                        <td rowSpan={accuracy.Accuracy_Parameters.length}>
                          {formatDate(accuracy?.date) || "-"}
                        </td>

                        <td rowSpan={accuracy.Accuracy_Parameters.length}>
                          {accuracy?.Test_Method?.name || "-"}
                        </td>
                        <td rowSpan={accuracy.Accuracy_Parameters.length}>
                          {accuracy?.Sample_Management?.unique_id || "-"}
                        </td>
                        <td rowSpan={accuracy.Accuracy_Parameters.length}>
                          {accuracy?.User?.name || "-"}
                        </td>
                        <td rowSpan={accuracy.Accuracy_Parameters.length}>
                          {accuracy?.remark || "-"}
                        </td>

                        <td rowSpan={accuracy.Accuracy_Parameters.length}>
                          {accuracy.Type_Of_Verification?.name || "-"}
                        </td>
                      </>
                    )}

                    {/* Parameter Name */}
                    <td>{param.Parameter?.name || "-"}</td>

                    {/* Certified Value */}
                    <td>{param.certified_value || "-"}</td>

                    {/* Tested Value */}
                    <td>{param.result_value || "-"}</td>

                    {/* Acceptance */}
                    {paramIndex === 0 && (
                      <>
                        <td rowSpan={accuracy.Accuracy_Parameters.length}>
                          Accepted
                        </td>
                      </>
                    )}

                    {paramIndex === 0 && (
                      <td rowSpan={accuracy.Accuracy_Parameters.length}>
                        {accuracy.certified_value || "-"}
                      </td>
                    )}

                    {/* {paramIndex === 0 && (
                      <td rowSpan={accuracy.Accuracy_Parameters.length}>
                        {accuracy.certified_value || "-"}
                      </td>
                    )} */}

                    {/* Action */}
                    <td>
                      {paramIndex === 0 && (
                        <div className="action_icons">
                          {haveEditPermission && (
                            <FontAwesomeIcon
                              icon={faPen}
                              onClick={() => {
                                setEdit(true);
                                setEditId(accuracy.id);
                              }}
                            />
                          )}
                          {haveDeletePermission && (
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              onClick={() => {
                                setSelectedDeleteId(accuracy.id); // store ID
                                setDelete(true); // open offcanvas
                              }}
                            />
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                )),
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(currentPage - 1) * itemsPerPage + 1} To{" "}
            {Math.min(currentPage * itemsPerPage, accuracydetails?.total || 0)}{" "}
            Of {accuracydetails?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      {/* Edit */}
      {haveEditPermission && (
        <Accuracy_Edit_Offcanvas
          show={showEdit}
          handleClose={() => setEdit(false)}
          id={showEditId}
        />
      )}

      {haveDeletePermission && (
        <Delete_offcanvas
          show={showDelete}
          handleClose={() => setDelete(false)}
          handleDelete={handleDelete}
          offcanvasHeading="Delete Accuracy"
          massageText={"Accuracy"}
          fetchCustomers={fetchCustomers}
        />
      )}
    </section>
  );
}

export default Accuracy_table;
